// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__3Sg8v","header":"PatientBlock_header__Zonhu","label":"PatientBlock_label__3Nkgf","option":"PatientBlock_option__1fmbw"};